import { render, staticRenderFns } from "./BulmaAutocomplete.vue?vue&type=template&id=18fe450a&scoped=true"
import script from "./BulmaAutocomplete.vue?vue&type=script&lang=js"
export * from "./BulmaAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./BulmaAutocomplete.vue?vue&type=style&index=0&id=18fe450a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fe450a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18fe450a')) {
      api.createRecord('18fe450a', component.options)
    } else {
      api.reload('18fe450a', component.options)
    }
    module.hot.accept("./BulmaAutocomplete.vue?vue&type=template&id=18fe450a&scoped=true", function () {
      api.rerender('18fe450a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaAutocomplete/BulmaAutocomplete.vue"
export default component.exports